import Link from '@commons/components/Link';
import RichText from '@commons/components/RichText';
import BaseContainer from '@commons/containers/BaseContainer';

import type { MemberNodeProps } from '.';
import styles from './Label.module.scss';

/**
 * Member Node Label component.
 */

const MemberNodeLabel = ({ title, alias, position }: MemberNodeProps) => (
  <BaseContainer width={12}>
    <Link reverse href={alias} scroll={false}>
      {title}
    </Link>
    {position && <RichText value={position} className={styles.position} />}
  </BaseContainer>
);

export default MemberNodeLabel;
